"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/faqSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FaqSectionAccordionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    className: string;
    /** Detected variants: "We encourage regular sessions to track progress and provide ongoing support. Frequency depends on individual needs." | "We recommend wellness check-ins every few months for infants, transitioning to annual visits for older children. These sessions are essential for tracking health, growth, and necessary vaccinations." | "Results vary depending on the treatment and skin condition. Some treatments show immediate results, while others may require multiple sessions." | "Yes, we recommend a consultation to understand your skin concerns and create a personalized treatment plan." */
    p0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" */
    id: string;
    /** Detected variants: "What age groups do you cater to in your wellness programs?" | "Is it possible to schedule a consultation online for services?" | "Can I arrange an online appointment for wellness consultations?" | "Does your clinic provide immunizations as part of your wellness services?" | "Are vaccinations available at your wellness clinic?" */
    a0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaExpanded: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    a0ClassName: string;
    /** Detected variants: "#collapseOne" | "#collapseTwo" | "#collapseThree" | "#collapseFour" | "#collapseFive" */
    dataBsTarget: string;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" | "headingFour" | "headingFive" */
    h30Id: string;
    /** Detected variants: "accordion-item" */
    divClassName?: string;
    /** Detected variants: "#faq-details-one" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName2?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
};
export type HomeEighteenFaqSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Common questions about our services" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Frequently Asked" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Questions" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "title" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/title-img-5.jpg" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div0Div0DivDataWowDuration?: string;
    /** Default: "faq-details-one" */
    sectionDiv0Div1Div0Div0Div0DivId?: string;
    /** Default: "shadow" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-shadow-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-shadow-2.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-shadow-3.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    sectionImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-shadow-4.png" */
    sectionImageWithBasePath3ImageSrc?: string;
    sectionImageWithBasePath3ImageVisible?: boolean;
    sectionImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    faqSectionAccordions: FaqSectionAccordionsItem[];
    faqSectionAccordionsItemWrapper?: (item: FaqSectionAccordionsItem, content: ReactNode) => ReactNode;
    faqSectionAccordionsRenderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsH3Visible?: boolean;
    faqSectionAccordionsH3Renderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsH3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
};

const HomeEighteenFaqSectionGenerated: FC<HomeEighteenFaqSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Common questions about our services",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Frequently Asked",
    sectionDiv0Div0H20H2Text2 = "Questions",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt = "title",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/title-img-5.jpg",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0Div0DivId = "faq-details-one",
    sectionDiv0Div1Div0Div0DivDataWowDuration = "1s",
    sectionImageWithBasePath0ImageAlt = "shadow",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/faq-shadow-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "shadow",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/faq-shadow-2.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "shadow",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/faq-shadow-3.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionImageWithBasePath3ImageAlt = "shadow",
    sectionImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/faq-shadow-4.png",
    sectionImageWithBasePath3ImageVisible,
    sectionImageWithBasePath3ImageRenderer,
    sectionImageWithBasePath3ImageProps,
    divH30H3Props,
    sectionDiv0Div1ClassName,
    faqSectionAccordions,
    faqSectionAccordionsItemWrapper,
    faqSectionAccordionsRenderer,
    faqSectionAccordionsH3Visible,
    faqSectionAccordionsH3Renderer,
    faqSectionAccordionsH3Props,
}) => {
    return (
        <section className="section faq-section-eighteen">
            <div className="container">
                <div className="section-header-eighteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            <span className="title-img">
                                {renderNode(sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center"}>
                    <div className="col-lg-10">
                        <div className="faq-info faq-info-eighteen wow zoomIn" data-wow-duration={sectionDiv0Div1Div0Div0DivDataWowDuration}>
                            <div className="accordion" id={sectionDiv0Div1Div0Div0Div0DivId}>
                                {renderCollectionNode(
                                    faqSectionAccordions,
                                    (item: FaqSectionAccordionsItem) => (
                                        <div className={item.divClassName ?? "accordion-item"} key={item.key}>
                                            {renderItemNode(faqSectionAccordionsH3Visible, faqSectionAccordionsH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof faqSectionAccordionsH3Props === "function" ? faqSectionAccordionsH3Props(item) : (faqSectionAccordionsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                    <a href={item.href ?? "#"} className={item.a0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} aria-controls={item.ariaControls}>{item.a0Text}</a>
                                                </h3>
                                            ))}
                                            <div id={item.id} className={item.className} data-bs-parent={item.dataBsParent ?? "#faq-details-one"}>
                                                <div className={item.div0ClassName ?? "accordion-body"}>
                                                    <div className={item.div0ClassName2 ?? "accordion-content"}>
                                                        <p>{item.p0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    faqSectionAccordionsItemWrapper,
                                    faqSectionAccordionsRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid shadow-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid shadow-2" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="img-fluid shadow-3" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath3ImageVisible, sectionImageWithBasePath3ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath3ImageSrc} alt={sectionImageWithBasePath3ImageAlt} className="img-fluid shadow-4" {...(sectionImageWithBasePath3ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeEighteenFaqSectionGenerated;
